export default __webpack_public_path__ + "static/media/teamsIconHCSelected.d2878b95.svg";